import { Image, Button, Tag, Card, Alert } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons"; // 引入返回图标
import { useNavigate } from "react-router-dom"; // 用于路由跳转
import img1 from '../images/crop_images.jpg';
// 模拟历史记录数据
const historyData = [
    {
        id: 1,
        score: 60,
        time: "2023-10-03 09:15",
        level: "较差",
        crop_url: img1,
        result: "1.寒凝血瘀；2.脾虚/气虚。",
        explanation: "舌头淡紫或青紫湿润的，多为寒凝血瘀，齿痕舌一般是脾虚或气虚导致的。"
    },
    {
        id: 2,
        score: 80,
        time: "2023-10-03 09:15",
        level: "良好",
        crop_url: img1,
        result: "1.寒凝血瘀；2.脾虚/气虚。",
        explanation: "舌头淡紫或青紫湿润的，多为寒凝血瘀，齿痕舌一般是脾虚或气虚导致的。"
    },
    {
        id: 3,
        score: 90,
        time: "2023-10-03 09:15",
        level: "优秀",
        crop_url: img1,
        result: "1.寒凝血瘀；2.脾虚/气虚。",
        explanation: "舌头淡紫或青紫湿润的，多为寒凝血瘀，齿痕舌一般是脾虚或气虚导致的。"
    }
];
const result = {
    // 穴位及穴数说明
    "acupointHealth": [
        "灸30分钟-关元穴 (单穴)",
        "灸30分钟-肾俞穴 (双穴)",
        "灸30分钟-膈俞穴 (双穴)",
        "灸30分钟-血海穴 (双穴)",
        "灸30分钟-足三里穴 (双穴)"
    ],
    "crop_buffer": "",
    "crop_url": "http://zhiyuan-ai-diagnosis.oss-cn-shenzhen.aliyuncs.com/crop_images%2F%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20250224101554_drop.jpg?OSSAccessKeyId=LTAI5tPp2AGkYfcbDG7GnJhC&Expires=1740394000&Signature=wP9%2Fi7EXWlwp9LMcz3lEOTTDX8o%3D",
    "explanation": "舌头淡紫或青紫湿润的，多为寒凝血瘀，齿痕舌一般是脾虚或气虚导致的。",
    "food": "饮食上少食肥腻寒凉的东西，多吃行气活血温性的食物。",
    "foodBetter": "宜食用性温味甘辛，具有健脾补气、温暖肠胃及祛寒作用的食物，如籼米、羊肉、鸡肉、牛肚、猪肚、鲢鱼、草鱼、荔枝、辣椒、韭菜、茴香菜、肉桂、干姜、生姜、花椒、胡椒、小茴香、白蔻、红糖等。",
    "foodWorse": "忌食寒凉、易损伤脾阳的食物：如苦瓜、冬瓜、柿子、香蕉、枇杷、梨、西瓜、绿豆、豆腐等。",
    "level": "良好",
    "medicine": "寒凝就是感受外在的风寒或者内在的寒邪，表现为肢寒怕冷、肢体关节疼痛、面色白、无汗、腹痛腹泻等。血瘀，是在寒凝的基础上发生的，寒邪的特点是收引，会收缩、凝滞血液，造成瘀血，出现皮肤紫暗、局部针刺样疼痛、夜间加剧、舌苔紫暗或者伴有瘀斑、瘀点。日常可用艾叶、当归、桂枝等中药泡脚，散寒化瘀。",
    "originalCoordinates": [
        [
            747,
            780
        ],
        [
            688,
            785
        ],
        [
            620,
            788
        ],
        [
            673,
            790
        ],
        [
            685,
            792
        ],
        [
            653,
            794
        ],
        [
            584,
            796
        ],
        [
            782,
            797
        ],
        [
            647,
            799
        ],
        [
            470,
            801
        ],
        [
            615,
            802
        ],
        [
            743,
            803
        ],
        [
            392,
            805
        ],
        [
            431,
            806
        ],
        [
            450,
            807
        ],
        [
            461,
            808
        ],
        [
            465,
            809
        ],
        [
            463,
            810
        ],
        [
            454,
            811
        ],
        [
            439,
            812
        ],
        [
            419,
            813
        ],
        [
            396,
            814
        ],
        [
            370,
            815
        ],
        [
            343,
            816
        ],
        [
            314,
            817
        ],
        [
            284,
            818
        ],
        [
            784,
            818
        ],
        [
            752,
            819
        ],
        [
            718,
            820
        ],
        [
            682,
            821
        ],
        [
            646,
            822
        ],
        [
            609,
            823
        ],
        [
            571,
            824
        ],
        [
            532,
            825
        ],
        [
            492,
            826
        ],
        [
            451,
            827
        ],
        [
            410,
            828
        ],
        [
            368,
            829
        ],
        [
            325,
            830
        ],
        [
            282,
            831
        ],
        [
            782,
            831
        ],
        [
            739,
            832
        ],
        [
            696,
            833
        ],
        [
            652,
            834
        ],
        [
            607,
            835
        ],
        [
            562,
            836
        ],
        [
            517,
            837
        ],
        [
            471,
            838
        ],
        [
            425,
            839
        ],
        [
            378,
            840
        ],
        [
            330,
            841
        ],
        [
            282,
            842
        ],
        [
            782,
            842
        ],
        [
            734,
            843
        ],
        [
            685,
            844
        ],
        [
            635,
            845
        ],
        [
            584,
            846
        ],
        [
            533,
            847
        ],
        [
            481,
            848
        ],
        [
            429,
            849
        ],
        [
            377,
            850
        ],
        [
            325,
            851
        ],
        [
            271,
            852
        ],
        [
            771,
            852
        ],
        [
            717,
            853
        ],
        [
            663,
            854
        ],
        [
            609,
            855
        ],
        [
            555,
            856
        ],
        [
            501,
            857
        ],
        [
            447,
            858
        ],
        [
            393,
            859
        ],
        [
            338,
            860
        ],
        [
            282,
            861
        ],
        [
            782,
            861
        ],
        [
            726,
            862
        ],
        [
            670,
            863
        ],
        [
            614,
            864
        ],
        [
            558,
            865
        ],
        [
            502,
            866
        ],
        [
            446,
            867
        ],
        [
            389,
            868
        ],
        [
            332,
            869
        ],
        [
            275,
            870
        ],
        [
            775,
            870
        ],
        [
            718,
            871
        ],
        [
            661,
            872
        ],
        [
            604,
            873
        ],
        [
            547,
            874
        ],
        [
            490,
            875
        ],
        [
            433,
            876
        ],
        [
            376,
            877
        ],
        [
            320,
            878
        ],
        [
            264,
            879
        ],
        [
            764,
            879
        ],
        [
            708,
            880
        ],
        [
            651,
            881
        ],
        [
            594,
            882
        ],
        [
            537,
            883
        ],
        [
            480,
            884
        ],
        [
            423,
            885
        ],
        [
            366,
            886
        ],
        [
            309,
            887
        ],
        [
            809,
            887
        ],
        [
            752,
            888
        ],
        [
            695,
            889
        ],
        [
            637,
            890
        ],
        [
            579,
            891
        ],
        [
            521,
            892
        ],
        [
            463,
            893
        ],
        [
            405,
            894
        ],
        [
            347,
            895
        ],
        [
            289,
            896
        ],
        [
            789,
            896
        ],
        [
            730,
            897
        ],
        [
            671,
            898
        ],
        [
            611,
            899
        ],
        [
            551,
            900
        ],
        [
            491,
            901
        ],
        [
            430,
            902
        ],
        [
            369,
            903
        ],
        [
            308,
            904
        ],
        [
            808,
            904
        ],
        [
            747,
            905
        ],
        [
            685,
            906
        ],
        [
            623,
            907
        ],
        [
            561,
            908
        ],
        [
            499,
            909
        ],
        [
            436,
            910
        ],
        [
            373,
            911
        ],
        [
            309,
            912
        ],
        [
            809,
            912
        ],
        [
            744,
            913
        ],
        [
            679,
            914
        ],
        [
            613,
            915
        ],
        [
            547,
            916
        ],
        [
            481,
            917
        ],
        [
            414,
            918
        ],
        [
            347,
            919
        ],
        [
            280,
            920
        ],
        [
            780,
            920
        ],
        [
            713,
            921
        ],
        [
            645,
            922
        ],
        [
            577,
            923
        ],
        [
            509,
            924
        ],
        [
            441,
            925
        ],
        [
            374,
            926
        ],
        [
            307,
            927
        ],
        [
            807,
            927
        ],
        [
            739,
            928
        ],
        [
            671,
            929
        ],
        [
            603,
            930
        ],
        [
            535,
            931
        ],
        [
            468,
            932
        ],
        [
            401,
            933
        ],
        [
            334,
            934
        ],
        [
            268,
            935
        ],
        [
            768,
            935
        ],
        [
            702,
            936
        ],
        [
            636,
            937
        ],
        [
            570,
            938
        ],
        [
            505,
            939
        ],
        [
            440,
            940
        ],
        [
            375,
            941
        ],
        [
            311,
            942
        ],
        [
            811,
            942
        ],
        [
            748,
            943
        ],
        [
            685,
            944
        ],
        [
            622,
            945
        ],
        [
            559,
            946
        ],
        [
            496,
            947
        ],
        [
            434,
            948
        ],
        [
            372,
            949
        ],
        [
            311,
            950
        ],
        [
            811,
            950
        ],
        [
            750,
            951
        ],
        [
            689,
            952
        ],
        [
            628,
            953
        ],
        [
            567,
            954
        ],
        [
            506,
            955
        ],
        [
            445,
            956
        ],
        [
            384,
            957
        ],
        [
            323,
            958
        ],
        [
            262,
            959
        ],
        [
            762,
            959
        ],
        [
            700,
            960
        ],
        [
            638,
            961
        ],
        [
            575,
            962
        ],
        [
            512,
            963
        ],
        [
            449,
            964
        ],
        [
            386,
            965
        ],
        [
            323,
            966
        ],
        [
            260,
            967
        ],
        [
            760,
            967
        ],
        [
            697,
            968
        ],
        [
            634,
            969
        ],
        [
            571,
            970
        ],
        [
            508,
            971
        ],
        [
            445,
            972
        ],
        [
            382,
            973
        ],
        [
            320,
            974
        ],
        [
            258,
            975
        ],
        [
            758,
            975
        ],
        [
            698,
            976
        ],
        [
            638,
            977
        ],
        [
            578,
            978
        ],
        [
            519,
            979
        ],
        [
            460,
            980
        ],
        [
            401,
            981
        ],
        [
            342,
            982
        ],
        [
            283,
            983
        ],
        [
            783,
            983
        ],
        [
            724,
            984
        ],
        [
            665,
            985
        ],
        [
            606,
            986
        ],
        [
            547,
            987
        ],
        [
            488,
            988
        ],
        [
            429,
            989
        ],
        [
            369,
            990
        ],
        [
            309,
            991
        ],
        [
            809,
            991
        ],
        [
            749,
            992
        ],
        [
            689,
            993
        ],
        [
            629,
            994
        ],
        [
            568,
            995
        ],
        [
            507,
            996
        ],
        [
            446,
            997
        ],
        [
            385,
            998
        ],
        [
            325,
            999
        ],
        [
            266,
            1000
        ],
        [
            766,
            1000
        ],
        [
            707,
            1001
        ],
        [
            648,
            1002
        ],
        [
            589,
            1003
        ],
        [
            530,
            1004
        ],
        [
            471,
            1005
        ],
        [
            413,
            1006
        ],
        [
            356,
            1007
        ],
        [
            299,
            1008
        ],
        [
            799,
            1008
        ],
        [
            742,
            1009
        ],
        [
            685,
            1010
        ],
        [
            628,
            1011
        ],
        [
            571,
            1012
        ],
        [
            515,
            1013
        ],
        [
            459,
            1014
        ],
        [
            404,
            1015
        ],
        [
            349,
            1016
        ],
        [
            294,
            1017
        ],
        [
            794,
            1017
        ],
        [
            739,
            1018
        ],
        [
            684,
            1019
        ],
        [
            630,
            1020
        ],
        [
            576,
            1021
        ],
        [
            523,
            1022
        ],
        [
            470,
            1023
        ],
        [
            417,
            1024
        ],
        [
            364,
            1025
        ],
        [
            311,
            1026
        ],
        [
            811,
            1026
        ],
        [
            758,
            1027
        ],
        [
            706,
            1028
        ],
        [
            654,
            1029
        ],
        [
            602,
            1030
        ],
        [
            550,
            1031
        ],
        [
            498,
            1032
        ],
        [
            447,
            1033
        ],
        [
            396,
            1034
        ],
        [
            346,
            1035
        ],
        [
            296,
            1036
        ],
        [
            796,
            1036
        ],
        [
            746,
            1037
        ],
        [
            696,
            1038
        ],
        [
            646,
            1039
        ],
        [
            597,
            1040
        ],
        [
            548,
            1041
        ],
        [
            499,
            1042
        ],
        [
            451,
            1043
        ],
        [
            403,
            1044
        ],
        [
            355,
            1045
        ],
        [
            308,
            1046
        ],
        [
            808,
            1046
        ],
        [
            761,
            1047
        ],
        [
            714,
            1048
        ],
        [
            667,
            1049
        ],
        [
            620,
            1050
        ],
        [
            574,
            1051
        ],
        [
            528,
            1052
        ],
        [
            482,
            1053
        ],
        [
            437,
            1054
        ],
        [
            392,
            1055
        ],
        [
            347,
            1056
        ],
        [
            302,
            1057
        ],
        [
            802,
            1057
        ],
        [
            757,
            1058
        ],
        [
            712,
            1059
        ],
        [
            667,
            1060
        ],
        [
            622,
            1061
        ],
        [
            577,
            1062
        ],
        [
            532,
            1063
        ],
        [
            488,
            1064
        ],
        [
            444,
            1065
        ],
        [
            401,
            1066
        ],
        [
            358,
            1067
        ],
        [
            315,
            1068
        ],
        [
            272,
            1069
        ],
        [
            772,
            1069
        ],
        [
            729,
            1070
        ],
        [
            687,
            1071
        ],
        [
            646,
            1072
        ],
        [
            605,
            1073
        ],
        [
            564,
            1074
        ],
        [
            523,
            1075
        ],
        [
            482,
            1076
        ],
        [
            441,
            1077
        ],
        [
            400,
            1078
        ],
        [
            359,
            1079
        ],
        [
            318,
            1080
        ],
        [
            277,
            1081
        ],
        [
            777,
            1081
        ],
        [
            737,
            1082
        ],
        [
            697,
            1083
        ],
        [
            657,
            1084
        ],
        [
            618,
            1085
        ],
        [
            579,
            1086
        ],
        [
            541,
            1087
        ],
        [
            503,
            1088
        ],
        [
            465,
            1089
        ],
        [
            427,
            1090
        ],
        [
            389,
            1091
        ],
        [
            353,
            1092
        ],
        [
            317,
            1093
        ],
        [
            281,
            1094
        ],
        [
            781,
            1094
        ],
        [
            745,
            1095
        ],
        [
            710,
            1096
        ],
        [
            676,
            1097
        ],
        [
            642,
            1098
        ],
        [
            608,
            1099
        ],
        [
            576,
            1100
        ],
        [
            544,
            1101
        ],
        [
            513,
            1102
        ],
        [
            482,
            1103
        ],
        [
            453,
            1104
        ],
        [
            424,
            1105
        ],
        [
            396,
            1106
        ],
        [
            369,
            1107
        ],
        [
            342,
            1108
        ],
        [
            316,
            1109
        ],
        [
            290,
            1110
        ],
        [
            790,
            1110
        ],
        [
            765,
            1111
        ],
        [
            740,
            1112
        ],
        [
            716,
            1113
        ],
        [
            693,
            1114
        ],
        [
            670,
            1115
        ],
        [
            647,
            1116
        ],
        [
            626,
            1117
        ],
        [
            605,
            1118
        ],
        [
            584,
            1119
        ],
        [
            564,
            1120
        ],
        [
            545,
            1121
        ],
        [
            526,
            1122
        ],
        [
            507,
            1123
        ],
        [
            490,
            1124
        ],
        [
            473,
            1125
        ],
        [
            456,
            1126
        ],
        [
            441,
            1127
        ],
        [
            426,
            1128
        ],
        [
            411,
            1129
        ],
        [
            398,
            1130
        ],
        [
            385,
            1131
        ],
        [
            374,
            1132
        ],
        [
            363,
            1133
        ],
        [
            352,
            1134
        ],
        [
            342,
            1135
        ],
        [
            333,
            1136
        ],
        [
            325,
            1137
        ],
        [
            317,
            1138
        ],
        [
            310,
            1139
        ],
        [
            304,
            1140
        ],
        [
            299,
            1141
        ],
        [
            294,
            1142
        ],
        [
            290,
            1143
        ],
        [
            790,
            1143
        ],
        [
            787,
            1144
        ],
        [
            785,
            1145
        ],
        [
            783,
            1146
        ],
        [
            782,
            1147
        ],
        [
            782,
            1148
        ],
        [
            782,
            1149
        ],
        [
            784,
            1150
        ],
        [
            786,
            1151
        ],
        [
            291,
            1153
        ],
        [
            295,
            1154
        ],
        [
            299,
            1155
        ],
        [
            304,
            1156
        ],
        [
            310,
            1157
        ],
        [
            316,
            1158
        ],
        [
            323,
            1159
        ],
        [
            331,
            1160
        ],
        [
            340,
            1161
        ],
        [
            350,
            1162
        ],
        [
            361,
            1163
        ],
        [
            373,
            1164
        ],
        [
            386,
            1165
        ],
        [
            401,
            1166
        ],
        [
            416,
            1167
        ],
        [
            432,
            1168
        ],
        [
            449,
            1169
        ],
        [
            466,
            1170
        ],
        [
            485,
            1171
        ],
        [
            504,
            1172
        ],
        [
            524,
            1173
        ],
        [
            545,
            1174
        ],
        [
            568,
            1175
        ],
        [
            591,
            1176
        ],
        [
            616,
            1177
        ],
        [
            642,
            1178
        ],
        [
            669,
            1179
        ],
        [
            698,
            1180
        ],
        [
            728,
            1181
        ],
        [
            759,
            1182
        ],
        [
            326,
            1184
        ],
        [
            361,
            1185
        ],
        [
            397,
            1186
        ],
        [
            435,
            1187
        ],
        [
            473,
            1188
        ],
        [
            513,
            1189
        ],
        [
            553,
            1190
        ],
        [
            595,
            1191
        ],
        [
            638,
            1192
        ],
        [
            683,
            1193
        ],
        [
            729,
            1194
        ],
        [
            325,
            1196
        ],
        [
            375,
            1197
        ],
        [
            426,
            1198
        ],
        [
            478,
            1199
        ],
        [
            531,
            1200
        ],
        [
            586,
            1201
        ],
        [
            642,
            1202
        ],
        [
            700,
            1203
        ],
        [
            320,
            1205
        ],
        [
            383,
            1206
        ],
        [
            446,
            1207
        ],
        [
            511,
            1208
        ],
        [
            577,
            1209
        ],
        [
            644,
            1210
        ],
        [
            712,
            1211
        ],
        [
            354,
            1213
        ],
        [
            427,
            1214
        ],
        [
            501,
            1215
        ],
        [
            577,
            1216
        ],
        [
            654,
            1217
        ],
        [
            733,
            1218
        ],
        [
            397,
            1220
        ],
        [
            481,
            1221
        ],
        [
            567,
            1222
        ],
        [
            653,
            1223
        ],
        [
            741,
            1224
        ],
        [
            421,
            1226
        ],
        [
            513,
            1227
        ],
        [
            607,
            1228
        ],
        [
            702,
            1229
        ],
        [
            396,
            1231
        ],
        [
            495,
            1232
        ],
        [
            596,
            1233
        ],
        [
            698,
            1234
        ],
        [
            407,
            1236
        ],
        [
            514,
            1237
        ],
        [
            623,
            1238
        ],
        [
            345,
            1240
        ],
        [
            459,
            1241
        ],
        [
            576,
            1242
        ],
        [
            695,
            1243
        ],
        [
            439,
            1245
        ],
        [
            563,
            1246
        ],
        [
            689,
            1247
        ],
        [
            449,
            1249
        ],
        [
            582,
            1250
        ],
        [
            359,
            1252
        ],
        [
            502,
            1253
        ],
        [
            647,
            1254
        ],
        [
            442,
            1256
        ],
        [
            593,
            1257
        ],
        [
            405,
            1259
        ],
        [
            565,
            1260
        ],
        [
            394,
            1262
        ],
        [
            563,
            1263
        ],
        [
            409,
            1265
        ],
        [
            587,
            1266
        ],
        [
            454,
            1268
        ],
        [
            642,
            1269
        ],
        [
            527,
            1271
        ],
        [
            425,
            1273
        ],
        [
            628,
            1274
        ],
        [
            544,
            1276
        ],
        [
            477,
            1278
        ],
        [
            427,
            1280
        ],
        [
            658,
            1281
        ],
        [
            636,
            1283
        ],
        [
            645,
            1285
        ],
        [
            461,
            1288
        ],
        [
            537,
            1290
        ],
        [
            456,
            1293
        ],
        [
            500,
            1296
        ]
    ],
    "original_url": "http://zhiyuan-ai-diagnosis.oss-cn-shenzhen.aliyuncs.com/original_images%2F%E5%BE%AE%E4%BF%A1%E5%9B%BE%E7%89%87_20250224101554.jpg?OSSAccessKeyId=LTAI5tPp2AGkYfcbDG7GnJhC&Expires=1740394000&Signature=AJPD0hbAK3rzwl0K3dhE0hrPbNw%3D",
    "relativeComparison": [
        [
            171,
            173
        ],
        [
            140,
            201
        ],
        [
            152,
            208
        ],
        [
            169,
            216
        ],
        [
            164,
            224
        ]
    ],
    "relativeOriginalCoordinates": [
        [
            276,
            72
        ],
        [
            250,
            74
        ],
        [
            221,
            76
        ],
        [
            244,
            77
        ],
        [
            249,
            77
        ],
        [
            235,
            78
        ],
        [
            205,
            79
        ],
        [
            291,
            80
        ],
        [
            233,
            80
        ],
        [
            156,
            81
        ],
        [
            219,
            82
        ],
        [
            274,
            82
        ],
        [
            122,
            83
        ],
        [
            139,
            83
        ],
        [
            147,
            84
        ],
        [
            152,
            84
        ],
        [
            154,
            85
        ],
        [
            153,
            85
        ],
        [
            149,
            86
        ],
        [
            143,
            86
        ],
        [
            134,
            86
        ],
        [
            124,
            87
        ],
        [
            113,
            87
        ],
        [
            101,
            88
        ],
        [
            89,
            88
        ],
        [
            76,
            89
        ],
        [
            292,
            89
        ],
        [
            278,
            89
        ],
        [
            263,
            89
        ],
        [
            248,
            90
        ],
        [
            232,
            90
        ],
        [
            216,
            91
        ],
        [
            200,
            91
        ],
        [
            183,
            92
        ],
        [
            166,
            92
        ],
        [
            148,
            93
        ],
        [
            130,
            93
        ],
        [
            112,
            93
        ],
        [
            93,
            94
        ],
        [
            75,
            94
        ],
        [
            291,
            94
        ],
        [
            272,
            95
        ],
        [
            254,
            95
        ],
        [
            235,
            96
        ],
        [
            215,
            96
        ],
        [
            196,
            96
        ],
        [
            176,
            97
        ],
        [
            157,
            97
        ],
        [
            137,
            98
        ],
        [
            116,
            98
        ],
        [
            96,
            99
        ],
        [
            75,
            99
        ],
        [
            291,
            99
        ],
        [
            270,
            99
        ],
        [
            249,
            100
        ],
        [
            227,
            100
        ],
        [
            205,
            101
        ],
        [
            183,
            101
        ],
        [
            161,
            102
        ],
        [
            138,
            102
        ],
        [
            116,
            102
        ],
        [
            93,
            103
        ],
        [
            70,
            103
        ],
        [
            286,
            103
        ],
        [
            263,
            104
        ],
        [
            240,
            104
        ],
        [
            216,
            105
        ],
        [
            193,
            105
        ],
        [
            170,
            105
        ],
        [
            146,
            106
        ],
        [
            123,
            106
        ],
        [
            99,
            107
        ],
        [
            75,
            107
        ],
        [
            291,
            107
        ],
        [
            267,
            108
        ],
        [
            243,
            108
        ],
        [
            218,
            109
        ],
        [
            194,
            109
        ],
        [
            170,
            109
        ],
        [
            146,
            110
        ],
        [
            121,
            110
        ],
        [
            96,
            111
        ],
        [
            72,
            111
        ],
        [
            288,
            111
        ],
        [
            263,
            112
        ],
        [
            239,
            112
        ],
        [
            214,
            112
        ],
        [
            189,
            113
        ],
        [
            165,
            113
        ],
        [
            140,
            114
        ],
        [
            115,
            114
        ],
        [
            91,
            115
        ],
        [
            67,
            115
        ],
        [
            283,
            115
        ],
        [
            259,
            115
        ],
        [
            234,
            116
        ],
        [
            210,
            116
        ],
        [
            185,
            117
        ],
        [
            160,
            117
        ],
        [
            136,
            118
        ],
        [
            111,
            118
        ],
        [
            86,
            118
        ],
        [
            303,
            118
        ],
        [
            278,
            119
        ],
        [
            253,
            119
        ],
        [
            228,
            120
        ],
        [
            203,
            120
        ],
        [
            178,
            121
        ],
        [
            153,
            121
        ],
        [
            128,
            121
        ],
        [
            103,
            122
        ],
        [
            78,
            122
        ],
        [
            294,
            122
        ],
        [
            269,
            123
        ],
        [
            243,
            123
        ],
        [
            217,
            124
        ],
        [
            191,
            124
        ],
        [
            165,
            125
        ],
        [
            139,
            125
        ],
        [
            112,
            125
        ],
        [
            86,
            126
        ],
        [
            302,
            126
        ],
        [
            276,
            126
        ],
        [
            249,
            127
        ],
        [
            222,
            127
        ],
        [
            195,
            128
        ],
        [
            169,
            128
        ],
        [
            141,
            128
        ],
        [
            114,
            129
        ],
        [
            86,
            129
        ],
        [
            303,
            129
        ],
        [
            275,
            130
        ],
        [
            247,
            130
        ],
        [
            218,
            131
        ],
        [
            189,
            131
        ],
        [
            161,
            131
        ],
        [
            132,
            132
        ],
        [
            103,
            132
        ],
        [
            74,
            133
        ],
        [
            290,
            133
        ],
        [
            261,
            133
        ],
        [
            232,
            134
        ],
        [
            202,
            134
        ],
        [
            173,
            134
        ],
        [
            144,
            135
        ],
        [
            115,
            135
        ],
        [
            86,
            136
        ],
        [
            302,
            136
        ],
        [
            272,
            136
        ],
        [
            243,
            137
        ],
        [
            214,
            137
        ],
        [
            184,
            137
        ],
        [
            155,
            138
        ],
        [
            126,
            138
        ],
        [
            97,
            139
        ],
        [
            69,
            139
        ],
        [
            285,
            139
        ],
        [
            256,
            140
        ],
        [
            228,
            140
        ],
        [
            199,
            141
        ],
        [
            171,
            141
        ],
        [
            143,
            141
        ],
        [
            115,
            142
        ],
        [
            87,
            142
        ],
        [
            304,
            142
        ],
        [
            276,
            143
        ],
        [
            249,
            143
        ],
        [
            222,
            144
        ],
        [
            195,
            144
        ],
        [
            167,
            144
        ],
        [
            141,
            145
        ],
        [
            114,
            145
        ],
        [
            87,
            146
        ],
        [
            304,
            146
        ],
        [
            277,
            146
        ],
        [
            251,
            147
        ],
        [
            224,
            147
        ],
        [
            198,
            147
        ],
        [
            172,
            148
        ],
        [
            145,
            148
        ],
        [
            119,
            149
        ],
        [
            93,
            149
        ],
        [
            66,
            150
        ],
        [
            282,
            150
        ],
        [
            256,
            150
        ],
        [
            229,
            150
        ],
        [
            202,
            151
        ],
        [
            174,
            151
        ],
        [
            147,
            152
        ],
        [
            120,
            152
        ],
        [
            93,
            153
        ],
        [
            65,
            153
        ],
        [
            282,
            153
        ],
        [
            254,
            154
        ],
        [
            227,
            154
        ],
        [
            200,
            154
        ],
        [
            173,
            155
        ],
        [
            145,
            155
        ],
        [
            118,
            156
        ],
        [
            91,
            156
        ],
        [
            64,
            157
        ],
        [
            281,
            157
        ],
        [
            255,
            157
        ],
        [
            229,
            157
        ],
        [
            203,
            158
        ],
        [
            177,
            158
        ],
        [
            152,
            159
        ],
        [
            126,
            159
        ],
        [
            101,
            160
        ],
        [
            75,
            160
        ],
        [
            291,
            160
        ],
        [
            266,
            160
        ],
        [
            240,
            161
        ],
        [
            215,
            161
        ],
        [
            189,
            162
        ],
        [
            164,
            162
        ],
        [
            138,
            163
        ],
        [
            112,
            163
        ],
        [
            86,
            163
        ],
        [
            303,
            163
        ],
        [
            277,
            164
        ],
        [
            251,
            164
        ],
        [
            225,
            165
        ],
        [
            198,
            165
        ],
        [
            172,
            166
        ],
        [
            146,
            166
        ],
        [
            119,
            166
        ],
        [
            93,
            167
        ],
        [
            68,
            167
        ],
        [
            284,
            167
        ],
        [
            259,
            168
        ],
        [
            233,
            168
        ],
        [
            208,
            169
        ],
        [
            182,
            169
        ],
        [
            157,
            170
        ],
        [
            131,
            170
        ],
        [
            107,
            170
        ],
        [
            82,
            171
        ],
        [
            298,
            171
        ],
        [
            274,
            171
        ],
        [
            249,
            172
        ],
        [
            224,
            172
        ],
        [
            200,
            173
        ],
        [
            176,
            173
        ],
        [
            151,
            173
        ],
        [
            128,
            174
        ],
        [
            104,
            174
        ],
        [
            80,
            175
        ],
        [
            296,
            175
        ],
        [
            272,
            175
        ],
        [
            249,
            176
        ],
        [
            225,
            176
        ],
        [
            202,
            176
        ],
        [
            179,
            177
        ],
        [
            156,
            177
        ],
        [
            133,
            178
        ],
        [
            110,
            178
        ],
        [
            87,
            179
        ],
        [
            304,
            179
        ],
        [
            281,
            179
        ],
        [
            258,
            179
        ],
        [
            236,
            180
        ],
        [
            213,
            180
        ],
        [
            191,
            181
        ],
        [
            168,
            181
        ],
        [
            146,
            182
        ],
        [
            124,
            182
        ],
        [
            102,
            182
        ],
        [
            81,
            183
        ],
        [
            297,
            183
        ],
        [
            275,
            183
        ],
        [
            254,
            184
        ],
        [
            232,
            184
        ],
        [
            211,
            185
        ],
        [
            190,
            185
        ],
        [
            169,
            186
        ],
        [
            148,
            186
        ],
        [
            127,
            186
        ],
        [
            106,
            187
        ],
        [
            86,
            187
        ],
        [
            302,
            187
        ],
        [
            282,
            188
        ],
        [
            262,
            188
        ],
        [
            241,
            189
        ],
        [
            221,
            189
        ],
        [
            201,
            189
        ],
        [
            181,
            190
        ],
        [
            161,
            190
        ],
        [
            142,
            191
        ],
        [
            122,
            191
        ],
        [
            103,
            192
        ],
        [
            83,
            192
        ],
        [
            300,
            192
        ],
        [
            280,
            192
        ],
        [
            261,
            193
        ],
        [
            241,
            193
        ],
        [
            222,
            194
        ],
        [
            202,
            194
        ],
        [
            183,
            195
        ],
        [
            164,
            195
        ],
        [
            145,
            195
        ],
        [
            126,
            196
        ],
        [
            108,
            196
        ],
        [
            89,
            197
        ],
        [
            70,
            197
        ],
        [
            287,
            197
        ],
        [
            268,
            198
        ],
        [
            250,
            198
        ],
        [
            232,
            198
        ],
        [
            214,
            199
        ],
        [
            197,
            199
        ],
        [
            179,
            200
        ],
        [
            161,
            200
        ],
        [
            144,
            201
        ],
        [
            126,
            201
        ],
        [
            108,
            202
        ],
        [
            90,
            202
        ],
        [
            73,
            202
        ],
        [
            289,
            202
        ],
        [
            272,
            203
        ],
        [
            254,
            203
        ],
        [
            237,
            204
        ],
        [
            220,
            204
        ],
        [
            203,
            205
        ],
        [
            187,
            205
        ],
        [
            170,
            205
        ],
        [
            154,
            206
        ],
        [
            137,
            206
        ],
        [
            121,
            207
        ],
        [
            105,
            207
        ],
        [
            90,
            208
        ],
        [
            74,
            208
        ],
        [
            291,
            208
        ],
        [
            275,
            208
        ],
        [
            260,
            209
        ],
        [
            245,
            209
        ],
        [
            231,
            210
        ],
        [
            216,
            210
        ],
        [
            202,
            211
        ],
        [
            188,
            211
        ],
        [
            175,
            211
        ],
        [
            161,
            212
        ],
        [
            149,
            212
        ],
        [
            136,
            213
        ],
        [
            124,
            213
        ],
        [
            112,
            214
        ],
        [
            101,
            214
        ],
        [
            89,
            214
        ],
        [
            78,
            215
        ],
        [
            295,
            215
        ],
        [
            284,
            215
        ],
        [
            273,
            216
        ],
        [
            263,
            216
        ],
        [
            253,
            217
        ],
        [
            243,
            217
        ],
        [
            233,
            218
        ],
        [
            224,
            218
        ],
        [
            214,
            218
        ],
        [
            205,
            219
        ],
        [
            197,
            219
        ],
        [
            189,
            220
        ],
        [
            180,
            220
        ],
        [
            172,
            221
        ],
        [
            165,
            221
        ],
        [
            157,
            221
        ],
        [
            150,
            222
        ],
        [
            144,
            222
        ],
        [
            137,
            223
        ],
        [
            131,
            223
        ],
        [
            125,
            224
        ],
        [
            119,
            224
        ],
        [
            115,
            224
        ],
        [
            110,
            225
        ],
        [
            105,
            225
        ],
        [
            101,
            226
        ],
        [
            97,
            226
        ],
        [
            93,
            227
        ],
        [
            90,
            227
        ],
        [
            87,
            227
        ],
        [
            84,
            228
        ],
        [
            82,
            228
        ],
        [
            80,
            229
        ],
        [
            78,
            229
        ],
        [
            295,
            229
        ],
        [
            293,
            230
        ],
        [
            292,
            230
        ],
        [
            291,
            231
        ],
        [
            291,
            231
        ],
        [
            291,
            231
        ],
        [
            291,
            232
        ],
        [
            292,
            232
        ],
        [
            293,
            233
        ],
        [
            79,
            234
        ],
        [
            80,
            234
        ],
        [
            82,
            234
        ],
        [
            84,
            235
        ],
        [
            87,
            235
        ],
        [
            89,
            236
        ],
        [
            93,
            236
        ],
        [
            96,
            237
        ],
        [
            100,
            237
        ],
        [
            104,
            237
        ],
        [
            109,
            238
        ],
        [
            114,
            238
        ],
        [
            120,
            239
        ],
        [
            126,
            239
        ],
        [
            133,
            240
        ],
        [
            140,
            240
        ],
        [
            147,
            240
        ],
        [
            154,
            241
        ],
        [
            163,
            241
        ],
        [
            171,
            242
        ],
        [
            179,
            242
        ],
        [
            189,
            243
        ],
        [
            198,
            243
        ],
        [
            208,
            243
        ],
        [
            219,
            244
        ],
        [
            231,
            244
        ],
        [
            242,
            245
        ],
        [
            255,
            245
        ],
        [
            268,
            246
        ],
        [
            281,
            246
        ],
        [
            94,
            247
        ],
        [
            109,
            247
        ],
        [
            125,
            248
        ],
        [
            141,
            248
        ],
        [
            157,
            249
        ],
        [
            175,
            249
        ],
        [
            192,
            250
        ],
        [
            210,
            250
        ],
        [
            229,
            250
        ],
        [
            248,
            251
        ],
        [
            268,
            251
        ],
        [
            93,
            252
        ],
        [
            115,
            253
        ],
        [
            137,
            253
        ],
        [
            160,
            253
        ],
        [
            182,
            254
        ],
        [
            206,
            254
        ],
        [
            231,
            255
        ],
        [
            256,
            255
        ],
        [
            91,
            256
        ],
        [
            118,
            256
        ],
        [
            146,
            257
        ],
        [
            174,
            257
        ],
        [
            202,
            258
        ],
        [
            231,
            258
        ],
        [
            261,
            259
        ],
        [
            106,
            259
        ],
        [
            137,
            260
        ],
        [
            170,
            260
        ],
        [
            202,
            261
        ],
        [
            236,
            261
        ],
        [
            270,
            262
        ],
        [
            125,
            263
        ],
        [
            161,
            263
        ],
        [
            198,
            263
        ],
        [
            235,
            264
        ],
        [
            273,
            264
        ],
        [
            135,
            265
        ],
        [
            175,
            266
        ],
        [
            215,
            266
        ],
        [
            256,
            266
        ],
        [
            124,
            267
        ],
        [
            167,
            268
        ],
        [
            211,
            268
        ],
        [
            255,
            269
        ],
        [
            129,
            269
        ],
        [
            175,
            270
        ],
        [
            222,
            270
        ],
        [
            102,
            271
        ],
        [
            151,
            272
        ],
        [
            202,
            272
        ],
        [
            253,
            272
        ],
        [
            143,
            273
        ],
        [
            196,
            274
        ],
        [
            251,
            274
        ],
        [
            147,
            275
        ],
        [
            205,
            275
        ],
        [
            108,
            276
        ],
        [
            170,
            277
        ],
        [
            233,
            277
        ],
        [
            144,
            278
        ],
        [
            209,
            279
        ],
        [
            128,
            279
        ],
        [
            197,
            280
        ],
        [
            123,
            281
        ],
        [
            196,
            281
        ],
        [
            130,
            282
        ],
        [
            207,
            282
        ],
        [
            149,
            283
        ],
        [
            231,
            284
        ],
        [
            181,
            285
        ],
        [
            137,
            285
        ],
        [
            224,
            286
        ],
        [
            188,
            287
        ],
        [
            159,
            288
        ],
        [
            137,
            288
        ],
        [
            237,
            289
        ],
        [
            228,
            290
        ],
        [
            232,
            291
        ],
        [
            152,
            292
        ],
        [
            185,
            293
        ],
        [
            150,
            294
        ],
        [
            169,
            295
        ]
    ],
    "remarks": "注：\n(1)每天按照第一天的调理方案循环灸治至痊愈为止。",
    "result": "1.寒凝血瘀；2.脾虚/气虚。",
    "score": 80,
    "symptomsIntroduction": "寒凝就是感受外在的风寒或者内在的寒邪，表现为肢寒怕冷、肢体关节疼痛、面色白、无汗、腹痛腹泻等。血瘀，是在寒凝的基础上发生的，寒邪的特点是收引，会收缩、凝滞血液，造成瘀血，出现皮肤紫暗、局部针刺样疼痛、夜间加剧、痛经、经期有血块、舌苔紫暗或者伴有瘀斑、瘀点。",
    "tongueColor": {
        "explain": "较红舌更深或略带暗红色。主里热亢盛、阴虚火旺。（注：此处青紫舌主病表述似与常见认知有偏差，常见为气血瘀滞等，可结合实际情况确认）",
        "type": "青紫舌"
    },
    "tongueFurColour": {
        "explain": "舌面上的舌苔呈现白色，是最常见的苔色。可为正常舌苔，疾病情况下主表证、寒证、湿证，也可见于热证",
        "type": "白苔"
    },
    "tongueFurQuality": [
        {
            "explain": "舌苔全部或部分剥落，剥落处舌面光滑无苔者，称为剥苔。一般主胃气匮乏，胃阴枯涸或气血两虚，亦是全身虚弱的一种征象",
            "type": "剥落苔"
        },
        {
            "explain": "厚苔：不能透过舌苔见到舌体。腻苔：苔质颗粒细腻致密，紧贴舌面，不容易刮掉。厚腻苔是由胃气挟湿浊、痰湿、食滞等邪气熏蒸所致；当痰湿浊邪化热时，还可在苔色上反映出来，如苔黄厚腻，为湿热、痰热、暑温等邪内蕴",
            "type": "厚腻苔"
        }
    ],
    "tongueShape": [
        {
            "explain": "舌体边缘有牙齿压迫的痕迹，常与胖大舌同见。主脾虚和湿盛",
            "type": "齿痕舌"
        },
        {
            "explain": "舌面上出现多少不等，深浅不一，各种形态的裂沟。裂纹舌多由舌体失养，舌面乳头萎缩或组织皲裂所致，是全身营养不良的一种表现。多见于精血亏虚，或阴虚火旺，或脾虚气弱者",
            "type": "裂纹舌"
        },
        {
            "explain": "舌体较正常舌大而厚，伸舌满口。主水湿痰饮阻滞",
            "type": "胖大舌"
        }
    ],
    "特征组合": "青紫舌,齿痕舌,裂纹舌,胖大舌,白苔,剥落苔,厚腻苔"
};
export default function TongueList() {
    const navigate = useNavigate(); // 获取路由跳转方法

    // 返回上一页
    const handleGoBack = () => {
        navigate(-1); // 返回上一页
    };

    return (
        <div className="tongue-list" style={{ minHeight: '100vh', width: '100%', height: '100%', backgroundColor: '#efefef' }}>
            <div style={{ backgroundColor: 'white' }}>
                <Button
                    type="text"
                    icon={<ArrowLeftOutlined />}
                    style={{ color: 'black', position: 'absolute', left: 1, top: 8 }}
                    onClick={handleGoBack}
                />
                <div style={{ color: 'black', textAlign: 'center', lineHeight: 3 }}>舌诊记录</div>
            </div>
            <div style={{ padding: '10px' }}>
                <Alert message="演示数据！ 此列表仅为演示使用。" showIcon type="warning" style={{ marginBottom: '10px' }} />
                {historyData.map(item => (
                    <Card
                        key={item.id}
                        style={{ backgroundColor: 'white', marginBottom: '10px' }}
                        onClick={() => {
                            navigate(`/detail`, {
                                state: {
                                    analysisResult: result
                                }
                            });
                        }}
                    >
                        <div style={{ display: 'flex', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <Tag color='blue' style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '3px' }}>
                                    <div style={{ marginRight: '8px' }}>
                                        <Image
                                            src={item.crop_url}
                                            width={40}
                                            height={40}
                                            preview={false}
                                            loading='lazy'
                                        />
                                    </div>
                                    <div>
                                        <p style={{ margin: '0', textAlign: 'center' }}>{item.score}分</p>
                                        <Tag color={
                                            item.level === '优秀' ? '#87d068' :
                                                item.level === '良好' ? '#2db7f5' : '#f50'
                                        } style={{ margin: '0' }}>{item.level || '未知'}</Tag>
                                    </div>
                                </Tag>
                                <div style={{ fontSize: 12, color: 'gray' }}>{item.time}</div>
                            </div>
                            <div>
                                <span style={{ fontSize: '14px', fontWeight: 'bold' }}>{item.result}</span>
                                <br />
                                <span>{item.explanation}</span>
                            </div>
                        </div>
                    </Card>
                ))}
            </div>
        </div>
    );
}
